<template>

    <div>
        <div class="row" v-bind:style="{ opacity: criarSenhaManual ? 0.4 : 1 }">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="password">Senha de acesso</label>
                    <input type="text" class="form-control" name="password" v-model="senhaPreConfigurada" readonly />
                </div>
            </div>
            <div class="col-md-6 mt-4" v-if="!criarSenhaManual">
                <button type="button" class="btn btn-primary bg-azul-escuro rounded-pill px-4" @click="criarSenhaManual = true;" >Deseja trocar a senha?</button>
            </div>
        </div>

        <div class="row" v-if="criarSenhaManual">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="password">Senha</label>
                    <input type="password" class="form-control" name="password" v-model="senhaCriada">
                </div>
                <div class="form-group">
                    <label for="passwordConfirmacao">Confirmar Nova Senha</label>
                    <input type="password" class="form-control" name="passwordConfirmacao" v-model="senhaCriadaConfirmacao">
                </div>
            </div>
            <div class="col-md-6 mt-4">
                <button type="button" class="btn btn-primary bg-azul-escuro rounded-pill px-4 mb-2" @click="criarSenhaManual = false;">Usar senha gerada</button>
                <div class="alert alert-secondary text-center">
                    <span class="small">Crie uma senha com no mínimo 6 caracteres. <!--Você <strong>pode</strong> usar letras, maiúsculas, números ou caracteres especiais (como $, #, @).--></span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <button type="button" class="btn btn-light border-primary rounded-pill px-4" @click="sendBack()">Voltar</button>
            </div>
            <div class="col-6 text-right">
                <button type="button" class="btn btn-primary bg-azul-escuro rounded-pill px-4" @click="finalizaCadastro()">Finalizar</button>
            </div>
        </div>
    </div>


</template>



<script>
    import { Api } from '@/common/api'
    import base from '@/common/base.js'

    export default {
        name: 'cadastro-senha',
        mixins: [base],
        props: {
            model: Object,
            senhaPreConfigurada: null,
            senhaCriada: null,
            senhaCriadaConfirmacao: null,
            criarSenhaManual: false,
        },
        methods: {
            finalizaCadastro() {
                this.showLoading();

                if (this.criarSenhaManual) {
                    this.model.password = this.senhaCriada;
                    this.model.passwordConfirmacao = this.senhaCriadaConfirmacao;
                }
                else {
                    this.model.password = this.senhaPreConfigurada;
                    this.model.passwordConfirmacao = this.senhaPreConfigurada;
                }

                new Api('pessoacna/finalizacadastro')
                    .post(this.model)
                    .then(result => {
                        this.hideLoading()
                        this.$emit('on-next', result.data)
                    }, err => {
                        this.defaultErrorResult(err, true);
                    })
            },
            sendBack() {
                this.$emit('on-back')
            }
        },

        mounted() {

            this.senhaPreConfigurada = this.model.codigoAcessoUtilizado;

            this.model.password = '';
            this.model.passwordConfirmacao = '';
        }
    };
</script>
